export const schemaCardStyles = {
  card: (isDragOverlay) => ({
    p: 1.25,
    mb: 1,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1.5,
    backgroundColor: 'background.paper',
    cursor: isDragOverlay ? 'grabbing' : 'grab',
    ...(isDragOverlay && { boxShadow: 6 }),
    '&:hover': { borderColor: 'text.secondary' },
  }),
  title: {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.3,
    mb: 0.5,
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap',
  },
  type: {
    fontSize: 12,
    color: 'text.secondary',
  },

  attrCount: {
    fontSize: 12,
    color: 'text.secondary',
  },
};
